import React from "react";
import styles from "./Footer.module.css";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <div className={styles.copyright}>
          <p>&copy; {currentYear} Lyra Productions LLC. All rights reserved.</p>
        </div>
        <div className={styles.credit}>
          <p>
            Built with ❤️ by a very good dog named{" "}
            <span className={styles.lyra}>Lyra</span> 🐕
          </p>
        </div>
      </div>
    </footer>
  );
};

Footer.displayName = "Footer";

export default Footer;
